import React from 'react';

interface RewardsProgressBarProps {
  progress: number;
  text: React.ReactNode;
  className?: string;
}

export const RewardsProgressBar: React.FC<RewardsProgressBarProps> = ({ progress, text, className }) => {
  const progressPercent = Math.min(Math.max(progress || 0, 0), 100);
  return (
    <div className={`ticket-progress-row ${className || ''}`}>
      <div className="progress-container">
        <span className="text text-right-side">{text}</span>
        <div className="progress-bar" style={{ width: `${progressPercent}%` }}>
          <div className="progress-bar-anim-row" />
          <span className="text text-left-side">{text}</span>
        </div>
      </div>
    </div>
  );
};
